// ============================================================
// AppAreaChart Component
// ============================================================

import {
  ResponsiveContainer,
  AreaChart,
  Area,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip as RechartsTooltip,
} from 'recharts';
import { tokens } from '@/theme/tokens';
import { Box } from '@mui/material';

export function AppAreaChart({ data, xAxisKey, dataKey, color = tokens.colors.primary.main, formatValue }) {
  return (
    <ResponsiveContainer width="100%" height="100%">
      <AreaChart data={data} margin={{ top: 10, right: 10, left: -20, bottom: 0 }}>
        <defs>
          <linearGradient id={`color-${dataKey}`} x1="0" y1="0" x2="0" y2="1">
            <stop offset="5%" stopColor={color} stopOpacity={0.3} />
            <stop offset="95%" stopColor={color} stopOpacity={0} />
          </linearGradient>
        </defs>
        <CartesianGrid strokeDasharray="3 3" vertical={false} stroke={tokens.colors.border} />
        <XAxis 
          dataKey={xAxisKey} 
          axisLine={false} 
          tickLine={false} 
          tick={{ fontSize: 12, fill: tokens.colors.text.secondary }}
          dy={10}
        />
        <YAxis 
          axisLine={false} 
          tickLine={false} 
          tick={{ fontSize: 12, fill: tokens.colors.text.secondary }}
          tickFormatter={(value) => formatValue ? formatValue(value) : value}
        />
        <RechartsTooltip
          contentStyle={{
            backgroundColor: tokens.colors.card,
            borderRadius: tokens.radius.md,
            border: `1px solid ${tokens.colors.border}`,
            boxShadow: tokens.shadows.md,
          }}
          formatter={(value) => [formatValue ? formatValue(value) : value, '']}
        />
        <Area 
          type="monotone" 
          dataKey={dataKey} 
          stroke={color} 
          strokeWidth={3}
          fillOpacity={1} 
          fill={`url(#color-${dataKey})`} 
        />
      </AreaChart>
    </ResponsiveContainer>
  );
}
